<template>
	<el-scrollbar height="270px" class="scrollbar-monitor">
		<div class="monitor_for" v-for="(item,index) in Now" :key="index">
			<div class="monitor_for_contain">
				<img src="../../../assets/home/monitor/boder.png" alt="" />
				<img :src="require('../../../assets/home/monitor/'+item.environmentId+'.png')" alt=""
					class="environmentIdimg" />
				<div class="monitor_for_value">
					{{item.environmentStr}} {{item.environmentUnit}}
				</div>
				<div class="monitor_for_title">
					{{item.environmentName}}
				</div>
			</div>
		</div>
	</el-scrollbar>

</template>

<script setup>
	import {
		ref
	} from 'vue';
	import {
		GetWeatherNow
	} from '@/api/api.js'
	let Now = ref()
	GetWeatherNow().then(res => {
		Now.value = res.data
	}).catch(err => {
		console.log(err)
	})
	setInterval(() => {
		GetWeatherNow().then(res => {
			Now.value = res.data
		}).catch(err => {
			console.log(err)
		})
	}, 600000)
</script>

<style lang="scss">
	.scrollbar-monitor {
		width: 100%;
		position: relative;
	}
	.el-scrollbar {
	    --el-scrollbar-opacity: 0.9 !important;
	    --el-scrollbar-bg-color: #34e2b7 !important; 
	}

	.monitor_for_contain {
		float: left;
		width: 105px;
		margin-top: 20px;
		margin-left: 20px;
		position: relative;

		.environmentIdimg {
			position: absolute;
			top: 17px;
			left: 10px;
		}

		.monitor_for_value {
			position: absolute;
			width: 100%;
			top: 5px;
			left: 45px;
			font-size: 12px;
		}

		.monitor_for_title {
			position: absolute;
			top: 22px;
			left: 45px;
			font-size: 11px;
			color: #2dffd0;
		}
	}
</style>